/**
 * FAQ page search: filters all FAQ sections on the page by question, answer, and topic.
 * Works with section "FAQ Search" (faq-search.liquid) and "FAQs" (faqs.liquid).
 */
(function () {
  function normalize (str) {
    if (typeof str !== 'string') return '';
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .trim();
  }

  function matches (term, item) {
    var q = normalize(item.getAttribute('data-faq-question') || '');
    var a = normalize(item.getAttribute('data-faq-answer') || '');
    var t = normalize(item.getAttribute('data-faq-topic') || '');
    return q.includes(term) || a.includes(term) || t.includes(term);
  }

  function runSearch (input) {
    var term = normalize(input.value);
    var sections = document.querySelectorAll('.section-faqs[data-faq-section-title]');

    sections.forEach(function (section) {
      var sectionTitle = normalize(section.getAttribute('data-faq-section-title') || '');
      var sectionMatchesTerm = term === '' || sectionTitle.includes(term);
      var items = section.querySelectorAll('.section-faqs__item');
      var visibleCount = 0;
      var subTitles = section.querySelectorAll('.section-faqs__sub-title');

      items.forEach(function (item) {
        var itemMatches = term === '' || matches(term, item);
        if (itemMatches) {
          item.classList.remove('faq-search-hidden');
          visibleCount++;
        } else {
          item.classList.add('faq-search-hidden');
        }
      });

      subTitles.forEach(function (sub) {
        var subText = normalize(sub.textContent || '');
        var subMatches = term === '' || subText.includes(term);
        if (subMatches) {
          sub.classList.remove('faq-search-hidden');
        } else {
          sub.classList.add('faq-search-hidden');
        }
      });

      if (term === '' || sectionMatchesTerm || visibleCount > 0) {
        section.classList.remove('faq-search-section-hidden');
      } else {
        section.classList.add('faq-search-section-hidden');
      }
    });
  }

  function init () {
    var input = document.querySelector('[data-faq-search-input]');
    if (!input) return;

    input.addEventListener('input', function () {
      runSearch(input);
    });
    input.addEventListener('keyup', function () {
      runSearch(input);
    });

    runSearch(input);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
